import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useHistory } from "react-router-dom";
import { getRiskDistribution } from "../../actions/riskManagement";

const ExternalSecurityRisk = () => {
    const { orgId } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const id = useSelector((state) => {
        return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    });
    const [isModal, setModal] = useState(1);
    const [riskValue, setRiskValue] = useState("");
    const riskDistribution = useSelector((state) => state?.riskManagement?.riskDistribution);

    useEffect(() => {
        if (id) {
            getRiskDistribution(id, dispatch);
        }
    }, [id, dispatch]);

    const getSeverityColor = (module) => {
        if (module.includes('high')) return 'danger';
        if (module.includes('medium')) return 'warning';
        return 'info';
    };

    const formatSeverityText = (module) => {
        return module.split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const routeCheck = (check) => {
            // Normal flow when multiple or no companies are selected
            if (check == 'High Risk Vulnerability') {
                history.push(`/known-vulnerabilities`);
            } else if (check == 'Exploitable Obsolete Technology') {
                history.push(`/web-technology`);
            } else if (check == 'Dangling Subdomain') {
                history.push(`/subdomains`);
            } else if (check == 'Expired Ssl Certificate') {
                history.push(`/vulnerable-certificates`);
            } else if (check == 'Vulnerable Obsolete Technology') {
                history.push(`/web-technology`);
            } else if (check == 'Stolen Cred') {
                history.push(`/stolen-credentials`);
            } else if (check == 'Malware Cred') {
                history.push(`/malware-credentials`);
            } else if (check == 'Leaked Session') {
                history.push(`/leaked-sessions`);
            } else if (check == 'Personal Information Breach') {
                history.push(`/pii`);
            } else if (check == 'Lookalike Domain') {
                history.push(`/look-alike`);
            } else if (check == 'Fake Social Media Profile') {
                history.push(`/social-media`);
            } else if (check == 'Leaked Code') {
                history.push(`/source-code`);
            } else if (check == 'Vulnerable Ssl Certificate') {
                history.push(`/vulnerable-certificates`);
            } else if (check == 'Postman') {
                history.push(`/postman-monitoring`);
            } else if (check == 'Telegram Forum') {
                history.push(`/telegram-monitoring`);
            } else if (check == 'Vulnerable Ssl Certificate') {
                history.push(`/vulnerable-certificates`);
            } else if(check == "Assets") {
                history.push(`/assets`);
            }

    };

    const handleRiskClick = (risk, category) => {
        const formattedRisk = formatSeverityText(risk.module);
        routeCheck(formattedRisk);
    };

    const renderRiskDistribution = () => {
        if (!riskDistribution) return null;

        return (
            <div className="card mt-4">
                <div className="card-header bg-white">
                    <h5 className="card-title mb-0">Risk Distribution</h5>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead className="thead-light">
                                <tr>
                                    <th className="border-0">Category</th>
                                    <th className="border-0">Module</th>
                                    <th className="border-0">Risk Description</th>
                                    <th className="border-0 text-center" style={{ width: '150px' }}>Severity</th>
                                    <th className="border-0 text-center" style={{ width: '100px' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {riskDistribution.attackSurface.map((risk, index) => (
                                    <tr key={`attack-${index}`}>
                                        <td className="align-middle">
                                            <span className="text-primary fw-medium">Attack Surface</span>
                                        </td>
                                        <td className="align-middle">{risk.moduleName}</td>
                                        <td className="align-middle">{risk.risk}</td>
                                        
                                        <td className="align-middle text-center">
                                            <span className={`badge px-3 py-2`}>
                                                {formatSeverityText(risk.module)}
                                            </span>
                                        </td>
                                        <td className="align-middle text-center" onClick={() => handleRiskClick(risk, 'attackSurface')}>
                                            <button 
                                                className="btn btn-sm btn-primary" 
                                            >
                                                View Details
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                {riskDistribution.dataExposure.map((risk, index) => (
                                    <tr key={`exposure-${index}`}>
                                        <td className="align-middle">
                                            <span className="text-primary fw-medium">Data Exposure</span>
                                        </td>
                                        <td className="align-middle">{risk.moduleName}</td>
                                        <td className="align-middle">{risk.risk}</td>
                                        <td className="align-middle text-center">
                                            <span className={`badge px-3 py-2`}>
                                                {formatSeverityText(risk.module)}
                                            </span>
                                        </td>
                                        <td className="align-middle text-center"  onClick={() => handleRiskClick(risk, 'dataExposure')}>
                                            <button 
                                                className="btn btn-sm btn-primary" 
                                            >
                                                View Details
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="container-fluid risk-dashboard">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h1 className="welcome-text">Third Party Risk Management</h1>
                        <nav aria-label="breadcrumb" className="mt-1">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/risk-register-vendor" className="welcome-textSmall">Risk management </Link>
                                </li>
                                <li className="breadcrumb-item">
                                    Risk Register Vendor
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            {renderRiskDistribution()}
        </div>
    );
};

export default ExternalSecurityRisk;
